import styled from 'styled-components';
import paddingMixin, { paddingPropTypes } from '../../../utils/styleProps/padding';
import colorMixin, { colorPropTypes } from '../../../utils/styleProps/color';
import typographyMixin, { typographyPropTypes } from '../../../utils/styleProps/typography';
import layoutMixin, { layoutPropTypes } from '../../../utils/styleProps/layout';
import backgroundMixin, { backgroundPropTypes } from '../../../utils/styleProps/background';
import flexMixin, { flexPropTypes } from '../../../utils/styleProps/flex';
import gridMixin, { gridPropTypes } from '../../../utils/styleProps/grid';
import borderMixin, { borderPropTypes } from '../../../utils/styleProps/border';
import positionMixin, { positionPropTypes } from '../../../utils/styleProps/position';
import effectMixin, { effectPropTypes } from '../../../utils/styleProps/effect';
import interactivityMixin, {
    interactivityPropTypes,
} from '../../../utils/styleProps/interactivity';
import transformMixin, { transformPropTypes } from '../../../utils/styleProps/transform';
import textDecorationMixin, {
    textDecorationPropTypes,
} from '../../../utils/styleProps/text-decoration';
import transitionMixin, { transitionPropTypes } from '../../../utils/styleProps/transition';
import marginMixin, { marginPropTypes } from '../../../utils/styleProps/margin';

/**
 * Box is the most abstract component on top of which other layout components are built.
 * By default, it renders a div element.
 *
 * References:
 * https://chakra-ui.com/docs/layout/box
 */
const Box = styled.div`
    ${backgroundMixin};
    ${borderMixin};
    ${colorMixin};
    ${effectMixin};
    ${flexMixin};
    ${gridMixin};
    ${interactivityMixin};
    ${layoutMixin};
    ${marginMixin};
    ${paddingMixin};
    ${positionMixin};
    ${textDecorationMixin};
    ${transformMixin};
    ${transitionMixin};
    ${typographyMixin};
`;

Box.propTypes = {
    ...backgroundPropTypes,
    ...borderPropTypes,
    ...colorPropTypes,
    ...effectPropTypes,
    ...flexPropTypes,
    ...gridPropTypes,
    ...interactivityPropTypes,
    ...layoutPropTypes,
    ...marginPropTypes,
    ...paddingPropTypes,
    ...positionPropTypes,
    ...textDecorationPropTypes,
    ...transformPropTypes,
    ...transitionPropTypes,
    ...typographyPropTypes,
};

export default Box;
